import {Type} from '@angular/core';
import {DatatableColumn} from './datatable-column';

export class ComponentColumn extends DatatableColumn {
  component: Type<any>;
}
